import { FeatureFlags } from '@constants/featureFlags';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';

/**
 * `true` renders the unified QuoteDetailsRowRender, `false` the legacy row
 * renderers. Reads the already-loaded feature-flag store, so it is synchronous.
 */
export const useLtlUnifiedQuoteComponent = () =>
  isFeatureFlagEnabled(FeatureFlags.LtlUnifiedQuoteComponent);
